import type { ReactElement } from "react";
import { Icon } from "@/components/Icon/Icon";
import type { SignInPending } from "../useSignInFlow";

function GoogleMark() {
  return (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <path d="M17.64 9.2c0-.64-.06-1.25-.16-1.84H9v3.49h4.84a4.14 4.14 0 0 1-1.8 2.71v2.26h2.91c1.7-1.57 2.69-3.88 2.69-6.62z" fill="#4285F4"/>
      <path d="M9 18c2.43 0 4.47-.81 5.96-2.18l-2.91-2.26c-.81.54-1.84.86-3.05.86-2.35 0-4.33-1.58-5.04-3.71H.96v2.33A8.997 8.997 0 0 0 9 18z" fill="#34A853"/>
      <path d="M3.96 10.71A5.41 5.41 0 0 1 3.68 9c0-.59.1-1.17.28-1.71V4.96H.96A8.997 8.997 0 0 0 0 9c0 1.45.35 2.82.96 4.04l3-2.33z" fill="#FBBC05"/>
      <path d="M9 3.58c1.32 0 2.51.45 3.44 1.35l2.58-2.58C13.46.89 11.43 0 9 0A8.997 8.997 0 0 0 .96 4.96l3 2.33C4.67 5.16 6.65 3.58 9 3.58z" fill="#EA4335"/>
    </svg>
  );
}

function MicrosoftMark() {
  return (
    <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <rect x="1" y="1" width="7.6" height="7.6" fill="#F25022"/>
      <rect x="9.4" y="1" width="7.6" height="7.6" fill="#7FBA00"/>
      <rect x="1" y="9.4" width="7.6" height="7.6" fill="#00A4EF"/>
      <rect x="9.4" y="9.4" width="7.6" height="7.6" fill="#FFB900"/>
    </svg>
  );
}

const MARKS: Record<string, () => ReactElement> = {
  google: GoogleMark,
  microsoft: MicrosoftMark,
};

const LABELS: Record<string, string> = {
  google: "Google",
  microsoft: "Microsoft",
};

export function providerLabel(provider: string): string {
  return (
    LABELS[provider] ??
    provider.charAt(0).toUpperCase() + provider.slice(1)
  );
}

type Props = {
  provider: string;
  onClick: () => void;
  pending: SignInPending;
  disabled?: boolean;
};

export function OAuthProviderButton({ provider, onClick, pending, disabled }: Props) {
  const Mark = MARKS[provider];
  const label = providerLabel(provider);

  return (
    <button
      type="button"
      className="signin-oauth"
      onClick={onClick}
      disabled={disabled || pending !== "none"}
    >
      {Mark ? <Mark /> : null}
      <span>Continue with {label}</span>
      {pending === "oauth" ? (
        <span className="shimmer" style={{ width: 12, height: 12, borderRadius: 6 }} />
      ) : (
        <Icon name="arrow-r" size={13} />
      )}
    </button>
  );
}
